import { useEffect, useRef, useState, Component } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import WorldCanvas from "@/components/world/WorldCanvas";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Journey from "@/components/Journey";
import Marquee from "@/components/Marquee";
import QuoteSection from "@/components/QuoteSection";
import SkillsBento from "@/components/SkillsBento";
import Hobbies from "@/components/Hobbies";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { chapters } from "@/data/portfolio";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center">
                    <div>
                        <p className="font-display text-2xl font-bold text-snow">Something broke the path.</p>
                        <p className="mt-3 font-mono text-xs text-mist">{String(this.state.error)}</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function Site() {
    const worldRef = useRef({ p: 0 });
    const [activeChapter, setActiveChapter] = useState(0);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="grain relative min-h-screen bg-transparent">
            <WorldCanvas worldRef={worldRef} activeChapter={activeChapter} chapters={chapters} />
            <Navbar />
            <main className="relative z-10">
                <Hero />
                <Journey worldRef={worldRef} activeChapter={activeChapter} setActiveChapter={setActiveChapter} />
                <Marquee />
                <QuoteSection />
                <SkillsBento />
                <Hobbies />
                <ContactSection />
                <Footer />
            </main>
        </div>
    );
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <Site />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
